<template>
  <div>
    <div class="eventInfo_status">
      <div class="attendance">
        <p>
          이벤트 참여자 <span>{{ joinCnt }}명</span>
        </p>
      </div>
      <div class="attendance_list" @click="goToAttendanceList">
        <p>참여자 목록</p>
      </div>
    </div>
      <div class="eventInfo_wrapper">
        <div class="talk_list">
          <!-- per talk -->
          <div class="talk_div">
            <div class="text_box">
              <div class="">
                <p class="subject">이벤트 내용</p>
                <p class="text" v-html="eventDesc.replace(/(?:\r\n|\r|\n)/g,'</br>')">
                </p>
              </div>
            </div>
          </div>

          <div class="talk_div">
            <div class="text_box">
              <div class="">
                <p class="subject">이벤트 기간</p>
                <p class="text">
                  {{ eventDate }}
                </p>
              </div>
            </div>
          </div>

          <div class="talk_div">
            <div class="text_box">
              <div class="">
                <p class="subject">이벤트 참여방법</p>
                <p class="text" v-html="eventHowto.replace(/(?:\r\n|\r|\n)/g,'</br>')">
                </p>
              </div>
            </div>
          </div>

          <div class="talk_div">
            <div class="text_box">
              <div class="">
                <p class="subject">당첨자 발표</p>
                <p class="text">
                  {{ eventWinnerOpenDateTime }}
                </p>
              </div>
            </div>
          </div>

          <div class="talk_div">
            <div class="text_box">
              <div class="">
                <p class="subject">당첨자 조건</p>
                <p class="text" v-html="winnerCondition.replace(/(?:\r\n|\r|\n)/g,'</br>')">
                </p>
              </div>
            </div>
          </div>
          <div class="talk_div" v-show="isIos">
            <div class="text_box">
              <div class="">
                <p class="text">* 해당 이벤트는 애플과 관련이 없습니다.</p>
              </div>
            </div>
          </div>
        </div>
    </div>  
  </div>
</template>

<script>
export default {
  props: {
    joinCnt: {
      type: Number
    },
    eventTitle: {
      type: String
    },
    eventDesc: {
      type: String
    },
    eventGift: {
      type: String
    },
    eventHowto: {
      type: String
    },
    winnerCondition: {
      type: String
    },
    eventDate: {
      type: String
    },
    eventWinnerOpenDateTime: {
      type: String
    },
    endTime: {
      type: String
    },
  },
  data() {
    return {
      isIos: false
    }
  },
  created() {
    var varUA = navigator.userAgent.toLowerCase();
    if ( varUA.indexOf("iphone") > -1||varUA.indexOf("ipad") > -1||varUA.indexOf("ipod") > -1 ) {
        this.isIos = true;
    }
  },
  methods: {
    goToAttendanceList() {
      this.$router.push({
        path: '/attendanceList', query: {
          nttId: this.$route.query.nttId
        }
      })
    }
  },

}
</script>

<style scoped>

.eventInfo_wrapper {
  padding: 0 0 30px 30px;
  background-color: #f2f3f6;
}
.eventInfo_wrapper p {
  font-weight: bold;
}
.eventInfo_wrapper > p {
  margin-right: 30px;
}
.eventInfo_wrapper p span {
  color: var(--Main-color);
  padding-left: 5px;
}
.eventInfo_wrapper .talk_box {
  margin: 20px 30px 0px 0;
  border-radius: 1.681vw;
  background-color: white;
  height: 50px;
  box-sizing: border-box;
  position: relative;
  box-shadow: 2px 2px 8px rgba(0, 0, 0, 0.1);
}
.eventInfo_wrapper .talk_box textarea {
  border-radius: 1.681vw;
  box-sizing: border-box;
  border: none;
  width: 77%;
  height: 100%;
  resize: none;
  padding: 15px;
}
.eventInfo_wrapper .talk_list .talk_div {
  padding: 20px 20px 20px 0;
  border-bottom: 0.266vw solid var(--Gray-Border);
  display: flex;
}
.eventInfo_wrapper .talk_list .talk_div .profile_pic {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  margin-right: 15px;
  flex-shrink: 0;
  flex-grow: 0;
}
.eventInfo_wrapper .talk_list .talk_div div {
}
.eventInfo_wrapper .talk_list .talk_div .text_box {
  flex-grow: 1;
}
.eventInfo_wrapper .talk_list .talk_div .text_box div {
  width: 100%;
}
.eventInfo_wrapper .talk_list .talk_div .text_box div p {
  width: 100%;
  font-size: 0.75em;
}
.eventInfo_wrapper .talk_list .talk_div .text_box div p span {
  padding-left: 0;
}
.eventInfo_wrapper .talk_list .talk_div .text_box div p .time {
  color: #9ea3ab;
  font-weight: normal;
  float: right;
}
.eventInfo_wrapper .talk_list .talk_div .text_box div .text {
  font-size: 14px;
  font-weight: normal;
  padding-top: 6px;
  letter-spacing: -0.02em;
}
.eventInfo_wrapper .talk_list .talk_div .text_box div .subject {
  color: #9EA3AB;
  font-size: 12px;
}
.eventInfo_wrapper .talk_more {
  width: 100%;
  padding: 20px 30px 20px 0;
  text-align: center;
  font-size: 0.75em;
}
.eventInfo_wrapper .talk_more .fa-chevron-down {
  padding-left: 1.401vw;
}

.eventInfo_status {
  display: flex;
  width: 100%;
  justify-content: space-between;
  height: 60px;
  border-top: 1px solid rgba(37, 45, 58, 0.3);
  border-bottom: 1px solid rgba(37, 45, 58, 0.3);
}

.eventInfo_status .attendance {
  padding: 0;
}

.eventInfo_status .attendance p{
  margin-top: 20px;
  margin-left: 20px;
}

.eventInfo_status .attendance p span {
  color: #FF7100;
  font-size: 16px;
}

.eventInfo_status .attendance_list p {
  color: #6F737A;
  font-size: 14px;
  margin-right: 20px;
  margin-top: 21px;
  text-decoration: underline;
}
</style>